import { createFileRoute } from '@tanstack/react-router';

import { getEnv } from '@apple/utils/config/env';

import { LogoutPage } from '@apple/features/auth/pages/LogoutPage';

const env = getEnv();

export const Route = createFileRoute('/(public)/logout')({
	loader: async ({ context }) => {
		if (context.auth.authenticated) {
			await context.auth.logout();
		}
	},
	component: LogoutRoute,
});

function LogoutRoute() {
	return <LogoutPage appName={env.APPLE_APP_TITLE} />;
}
